// Kurerad palett med tillräckligt mörka färger – alla klarar WCAG AA (>= 4.5:1) mot vit text.
const AVATAR_COLORS = ['#0b6bcb', '#5b3fb3', '#1f7a3d', '#b3261e', '#8a5000', '#00696e', '#8e1f6b', '#374151', '#9a3412', '#155e75'];

// Deterministisk avatarfärg utifrån namnet (samma person -> samma färg).
export const avatarColorFromName = (value: string) => {
  let hash = 0;
  /* eslint-disable no-bitwise */
  for (let i = 0; i < (value || '').length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  /* eslint-enable no-bitwise */
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
